export default __webpack_public_path__ + "static/media/white-front.e5b707f8.png";